export const ACTION_TYPES = {
  ERROR: 'ERROR',
};

const initialState = {
  hasError: false,
  error: null,
};

// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.ERROR:
      return {
        ...initialState,
        hasError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
